/**
 * MetricsCard Component
 *
 * Display key metrics as large numbers with labels.
 */

import './charts.css'

interface MetricEntry {
  name: string
  value: number
  suffix?: string
  color: string
}

interface MetricsCardProps {
  entries: MetricEntry[]
  title?: string
}

export function MetricsCard({ entries, title }: MetricsCardProps) {
  return (
    <div className="metrics-card">
      {title && <h3 className="chart-title">{title}</h3>}

      <div className="metrics-card__grid">
        {entries.map((entry) => (
          <div
            key={entry.name}
            className="metrics-card__item"
            style={{ '--metric-color': entry.color } as React.CSSProperties}
          >
            <div className="metrics-card__value">
              {entry.value}
              {entry.suffix && (
                <span className="metrics-card__suffix">{entry.suffix}</span>
              )}
            </div>
            <div className="metrics-card__label">{entry.name}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MetricsCard
